import React from 'react';
import { Phone, CheckCircle, AlertTriangle, Lightbulb, Snowflake } from 'lucide-react';
export function TravelTrailerRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-7497">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-7498">
        <div className="container mx-auto px-4" data-id="element-7499">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-7500">
            RV and Trailer Repair Service
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-7501">
            Plumbing Repair • Generator Repair • Wiring Repair • Tow Bars • Roof
            Repair
          </p>
          <p className="text-lg text-gray-100 text-center mt-2" data-id="element-7502">
            Restorations • Detailing • Propane Systems • Boat Loaders • Overload
            Springs
          </p>
          <p className="text-lg text-gray-100 text-center" data-id="element-7503">
            Weight Distribution • Sway Control • Self-Adjusting Air-Ride Systems
            • Hitches
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-7504">
        <div className="max-w-6xl mx-auto" data-id="element-7505">
          {/* Services Overview */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7506">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-7507">
              Complete RV & Trailer Services
            </h2>

            <div className="grid md:grid-cols-3 gap-4" data-id="element-7508">
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7509">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7510" />
                <span className="text-gray-700" data-id="element-7511">Plumbing Repair</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7512">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7513" />
                <span className="text-gray-700" data-id="element-7514">Generator Repair</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7515">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7516" />
                <span className="text-gray-700" data-id="element-7517">Wiring Repair</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7518">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7519" />
                <span className="text-gray-700" data-id="element-7520">Tow Bars</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7521">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7522" />
                <span className="text-gray-700" data-id="element-7523">Roof Repair</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7524">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7525" />
                <span className="text-gray-700" data-id="element-7526">Restorations</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7527">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7528" />
                <span className="text-gray-700" data-id="element-7529">Detailing</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7530">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7531" />
                <span className="text-gray-700" data-id="element-7532">Propane Systems</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7533">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7534" />
                <span className="text-gray-700" data-id="element-7535">Boat Loaders</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7536">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7537" />
                <span className="text-gray-700" data-id="element-7538">Overload Springs</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7539">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7540" />
                <span className="text-gray-700" data-id="element-7541">Weight Distribution</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7542">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7543" />
                <span className="text-gray-700" data-id="element-7544">Sway Control</span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7545">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7546" />
                <span className="text-gray-700" data-id="element-7547">
                  Self-Adjusting Air-Ride Systems
                </span>
              </div>
              <div className="flex items-center bg-blue-50 rounded p-3" data-id="element-7548">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7549" />
                <span className="text-gray-700" data-id="element-7550">Hitches</span>
              </div>
            </div>
          </div>

          {/* Winterization Tips */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7551">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center flex items-center justify-center" data-id="element-7552">
              <Snowflake className="mr-3 text-blue-600" size={32} data-id="element-7553" />
              Winterization Tips
            </h2>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-7554">
              <div data-id="element-7555">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-7556">
                  To prepare your rig's plumbing systems for winter storage
                </h3>

                <div className="space-y-4" data-id="element-7557">
                  <div className="bg-blue-50 border-l-4 border-blue-500 p-4" data-id="element-7558">
                    <p className="font-semibold text-gray-900 mb-2" data-id="element-7559">
                      1. Drain all tanks
                    </p>
                    <p className="text-gray-700" data-id="element-7560">
                      Flush out the black water and gray water tanks and be sure
                      to get them as empty as possible. Drain the fresh water
                      tank.
                    </p>
                  </div>

                  <div className="bg-green-50 border-l-4 border-green-500 p-4" data-id="element-7561">
                    <p className="font-semibold text-gray-900 mb-2" data-id="element-7562">
                      2. Drain the water heater
                    </p>
                    <p className="text-gray-700" data-id="element-7563">
                      Drain the water heater and close the drain valve.
                    </p>
                  </div>

                  <div className="bg-purple-50 border-l-4 border-purple-500 p-4" data-id="element-7564">
                    <p className="font-semibold text-gray-900 mb-2" data-id="element-7565">
                      3. Drain fresh water plumbing system
                    </p>
                    <p className="text-gray-700" data-id="element-7566">
                      Use low point drains if provided. Open all faucets and
                      step on the toilet pedal as well. Get as much water out of
                      the system as possible. Close the low point drains.
                    </p>
                  </div>

                  <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4" data-id="element-7567">
                    <p className="font-semibold text-gray-900 mb-2" data-id="element-7568">
                      4. Winterize appliances
                    </p>
                    <p className="text-gray-700" data-id="element-7569">
                      If your rig is equipped with an icemaker or washer/dryer,
                      follow the manufacturer's recommended procedures to
                      winterize and protect these appliances.
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center" data-id="element-7570">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/Spree_RV_Trailer.jpg?opt=w3" alt="RV Trailer" className="rounded-lg shadow-md max-w-full h-auto" data-id="element-7571" />
              </div>
            </div>
          </div>

          {/* Mouse Damage Warning */}
          <div className="bg-red-50 border-2 border-red-500 rounded-lg shadow-md p-8 mb-8" data-id="element-7572">
            <div className="flex items-start mb-6" data-id="element-7573">
              <AlertTriangle className="text-red-600 mr-4 flex-shrink-0 mt-1" size={32} data-id="element-7574" />
              <div data-id="element-7575">
                <h2 className="text-2xl font-bold text-red-900 mb-4" data-id="element-7576">
                  Protect Your RV from Mouse Damage
                </h2>
                <p className="text-lg text-gray-800 mb-4" data-id="element-7577">
                  If mice have infested your home-away-from-home, then{' '}
                  <strong data-id="element-7578">your vehicle is prone to the expensive damage</strong>{' '}
                  resulting from mice chewing through wiring and nesting in
                  vital components.
                </p>
                <p className="text-gray-800" data-id="element-7579">
                  Even worse, you and your family could be prone to offensive
                  odors, potential messes and even disease.
                </p>
              </div>
            </div>

            <div className="text-center" data-id="element-7580">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/chewed-wires.jpg?opt=w3" alt="Chewed wires from mouse damage" className="mx-auto rounded-lg shadow-sm" data-id="element-7581" />
            </div>
          </div>

          {/* Helpful Tips */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7582">
            <div className="flex items-center justify-center mb-6" data-id="element-7583">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/mouse.jpg?opt=w3" alt="Mouse" className="mr-4" data-id="element-7584" />
              <h2 className="text-4xl font-bold text-gray-900 flex items-center" data-id="element-7585">
                <Lightbulb className="mr-3 text-yellow-500" size={40} data-id="element-7586" />
                Helpful Tips
              </h2>
            </div>

            <div className="space-y-6" data-id="element-7587">
              <div className="bg-green-50 border-l-4 border-green-500 p-6" data-id="element-7588">
                <p className="text-gray-800 italic mb-2" data-id="element-7589">
                  <strong data-id="element-7590">
                    "We have had two Trailers next to each other, one protected
                    with dryer sheets, the other not, the one without the dryer
                    sheets was destroyed by mice, the one with the dryer sheets
                    was clean as a whistle, and smelled pretty good, to boot.
                    The dryer sheets really, truly work."
                  </strong>
                </p>
                <p className="text-gray-600 italic text-right" data-id="element-7591">- Karen Short</p>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-6" data-id="element-7592">
                <p className="text-gray-800 italic mb-2" data-id="element-7593">
                  <strong data-id="element-7594">
                    "I put bounty dryer sheets in all the corners and in the
                    cupboards. I have done this for the last 5 years and I have
                    had zero problems with mice."
                  </strong>
                </p>
                <p className="text-gray-600 italic text-right" data-id="element-7595">- Kevin Brown</p>
              </div>

              <div className="bg-yellow-50 border-2 border-yellow-500 rounded-lg p-6 text-center" data-id="element-7596">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7597">
                  Simple Mouse Prevention Solution
                </h3>
                <p className="text-lg text-gray-800" data-id="element-7598">
                  Place dryer sheets in corners, cupboards, and storage areas to
                  keep mice away naturally and keep your RV smelling fresh!
                </p>
              </div>
            </div>
          </div>

          {/* Service Categories */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7599">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-7600">
              Our RV & Trailer Expertise
            </h2>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-7601">
              <div className="bg-blue-50 rounded-lg p-6" data-id="element-7602">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-7603">
                  Systems & Mechanical
                </h3>
                <ul className="space-y-2" data-id="element-7604">
                  <li className="flex items-start" data-id="element-7605">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7606" />
                    <span className="text-gray-700" data-id="element-7607">
                      Plumbing systems repair and winterization
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7608">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7609" />
                    <span className="text-gray-700" data-id="element-7610">
                      Generator service and repair
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7611">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7612" />
                    <span className="text-gray-700" data-id="element-7613">
                      Electrical wiring and systems
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7614">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7615" />
                    <span className="text-gray-700" data-id="element-7616">
                      Propane system inspection and repair
                    </span>
                  </li>
                </ul>
              </div>

              <div className="bg-green-50 rounded-lg p-6" data-id="element-7617">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-7618">
                  Exterior & Structural
                </h3>
                <ul className="space-y-2" data-id="element-7619">
                  <li className="flex items-start" data-id="element-7620">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7621" />
                    <span className="text-gray-700" data-id="element-7622">
                      Roof repair and resealing
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7623">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7624" />
                    <span className="text-gray-700" data-id="element-7625">Complete restorations</span>
                  </li>
                  <li className="flex items-start" data-id="element-7626">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7627" />
                    <span className="text-gray-700" data-id="element-7628">
                      Professional detailing
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7629">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7630" />
                    <span className="text-gray-700" data-id="element-7631">Structural repairs</span>
                  </li>
                </ul>
              </div>

              <div className="bg-purple-50 rounded-lg p-6" data-id="element-7632">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-7633">
                  Towing & Suspension
                </h3>
                <ul className="space-y-2" data-id="element-7634">
                  <li className="flex items-start" data-id="element-7635">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7636" />
                    <span className="text-gray-700" data-id="element-7637">
                      Tow bar installation and service
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7638">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7639" />
                    <span className="text-gray-700" data-id="element-7640">
                      Weight distribution systems
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7641">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7642" />
                    <span className="text-gray-700" data-id="element-7643">
                      Sway control installation
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7644">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7645" />
                    <span className="text-gray-700" data-id="element-7646">
                      Air-ride suspension systems
                    </span>
                  </li>
                </ul>
              </div>

              <div className="bg-yellow-50 rounded-lg p-6" data-id="element-7647">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-7648">
                  Accessories & Upgrades
                </h3>
                <ul className="space-y-2" data-id="element-7649">
                  <li className="flex items-start" data-id="element-7650">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7651" />
                    <span className="text-gray-700" data-id="element-7652">Boat loader systems</span>
                  </li>
                  <li className="flex items-start" data-id="element-7653">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7654" />
                    <span className="text-gray-700" data-id="element-7655">
                      Overload spring installation
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7656">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7657" />
                    <span className="text-gray-700" data-id="element-7658">
                      Hitch installation and service
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-7659">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7660" />
                    <span className="text-gray-700" data-id="element-7661">
                      Custom upgrades and modifications
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-7662">
            <h2 className="text-3xl font-bold mb-4" data-id="element-7663">
              Expert RV & Trailer Repair Services
            </h2>
            <p className="text-xl mb-6" data-id="element-7664">
              Complete service, repair, and winterization for your home away
              from home
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-7665">
              <Phone className="mr-3" size={24} data-id="element-7666" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-7667">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}